import { Suspense, useEffect, useState } from "react";

import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import Spinner from "react-bootstrap/Spinner";

import Home from "../pages/home";

import Event from "../pages/event";

import Search from "../pages/search";

import EventDetail from "../pages/event/EventDetail";
import Reservas from "../pages/reservas";
import BarDetail from "../pages/reservas/BarDetail";
import ReservaSuccess from "../pages/reservas/ReservaSuccess";
import ReservaCancel from "../pages/reservas/ReservaCancel";
import LegacyReservationOutcomeRedirect from "../pages/reservas/LegacyReservationOutcomeRedirect";
import Historial from "../pages/reservas/Historial";
import ManageReservation from "../pages/reservas/ManageReservation";
import ReviewByLink from "../pages/reservas/ReviewByLink";
import WaitlistLeave from "../pages/listaDeEspera/WaitlistLeave";
import WaitlistClaim from "../pages/listaDeEspera/WaitlistClaim";
import NewsUnsubscribe from "../pages/novedades/NewsUnsubscribe";
import Canchas from "../pages/canchas";
import ClubDetail from "../pages/canchas/ClubDetail";
import ClubOpenMatches from "../pages/canchas/ClubOpenMatches";
import OpenMatchDetail from "../pages/canchas/OpenMatchDetail";
import BirthdayFlow from "../pages/cumpleanos/BirthdayFlow";
import BirthdayRequestPage from "../pages/cumpleanos/BirthdayRequestPage";
import BeautyListing from "../pages/beauty";
import SalonDetail from "../pages/beauty/SalonDetail";
import PreviewEntry from "../pages/preview/PreviewEntry";

import RegisterForm from "../pages/auth/register";
import CompleteProfile from "../pages/auth/CompleteProfile";
import Login from "../pages/auth/login";
import EntrarDesdeZoco from "../pages/auth/EntrarDesdeZoco";

import NotFound from "./404pagenotfound";

import { GoogleOAuthProvider } from "@react-oauth/google";

import { getAppSettings } from "../api/api";

import ForgotPassword from "../pages/auth/forgotpassword";

import { useSelector } from "react-redux";

import ContactUs from "../pages/contectus";

import Blog from "../pages/blog";

import BlogDetail from "../pages/blog/blogdetail";

import Cart from "../pages/cart";

import Order from "../pages/order";
import MyEvents from "../pages/myevents";
import MyEventDetail from "../pages/myevents/detail";
import TransferTickets from "../pages/myevents/Transfer";
import AccountProfile from "../pages/account/Profile";
import AccountPassword from "../pages/account/ChangePassword";
// Removed legacy non-Clover checkout pages

import Cancel from "../pages/cart/cancel";

import PrivacyPolicy from "../pages/privacypolicy";

import TermsAndCondition from "../pages/termsandcondition";
import RegretButton from "../pages/arrepentimiento";

import OrganizerLayout from "../organizer/Layout";

import OrganizerLiveAttendance from "../organizer/attendance/LiveAttendance";

import OrganizerEventsList from "../organizer/events/EventsList";

import OrganizerEventForm from "../organizer/events/EventForm";
import OrganizerEventGuidedFlow from "../organizer/events/primerUso/EventGuidedFlow";

import OrganizerScanners from "../organizer/scanners/Scanners";
import OrganizerSellers from "../organizer/sellers/Sellers";
import OrganizerCoupons from "../organizer/coupons/Coupons";
import OrganizerGiftTickets from "../organizer/gifts/Gifts";
import OrganizerReferrals from "../organizer/referrals/Referrals";
import OrganizerSponsors from "../organizer/sponsors/Sponsors";
import OrganizerOrders from "../organizer/orders/Orders";
import OrganizerReports from "../organizer/reports/Reports";
import OrganizerMarketing from "../organizer/marketing/Marketing";
import OrganizerPhysicalTickets from "../organizer/physical/PhysicalTickets";
import OrganizerPhysicalPrintBatch from "../organizer/physical/PrintBatch";
import OrganizerReservas from "../organizer/reservas/ReservasOrganizer";
import CanchasOrganizer from "../organizer/canchas/CanchasOrganizer";
import BirthdayInbox from "../organizer/canchas/BirthdayInbox";
import EstadisticasCanchas from "../organizer/estadisticas/EstadisticasCanchas";
import EstadisticasBeauty from "../organizer/estadisticas/EstadisticasBeauty";
import TurnosOrganizer from "../organizer/turnos/TurnosOrganizer";
import ClientesOrganizer from "../organizer/clientes/ClientesOrganizer";
import OrganizerPayments from "../organizer/payments/Payments";
import OrganizerNotificationPreferences from "../organizer/notificaciones/NotificationPreferences";
// Use the actual file path (Linux is case-sensitive)
import SuccessCloverPage from "../pages/clover/success/Success";
import SuccessFiservPage from "../pages/fiserv/success/Success";
import CancelFiservPage from "../pages/fiserv/cancel/Cancel";
import TransferAccept from "../pages/transfer/Accept";
import LoginGate from "./LoginGate";
import PublicLoginRoute from "./PublicLoginRoute";
import { RequireOrganizerRole, RequireTarjetaDelNegocio, OrganizerIndexGate } from "./organizerAccessGuards";
const PrivateRoute = ({ children }) => {
	const auth = useSelector((state) => state.auth);
	const location = useLocation();

	if (!auth.isAuthenticated) {
		return <Navigate to="/login" replace state={{ from: location.pathname, ...(/^\/cart(\/|$)/.test(location.pathname) ? { reason: "checkout" } : {}) }} />;
	}

	return children;
};

const PublicRoute = ({ children }) => {
	const auth = useSelector((state) => state.auth);

	if (auth.isAuthenticated) {
		const role = auth?.user?.role;

		if (role === "ORGANIZER" || role === "SELLER")
			return <Navigate to="/organizer" replace />;

		return <Navigate to="/event" replace />;
	}

	return children;
};

const PrivateOrganizerRoute = ({ children }) => {
	const auth = useSelector((state) => state.auth);

	if (!auth.isAuthenticated) return <Navigate to="/login" replace />;

	const role = auth?.user?.role;

	if (role !== "ORGANIZER" && role !== "SELLER")
		return <Navigate to="/event" replace />;

	return children;
};

// RequireOrganizerRole y OrganizerIndexGate viven en organizerAccessGuards.jsx (organizer-permission-guards,
// slice 3): así un test puede ejercitarlas sin importar este archivo entero, que arrastra cada página del sitio.

const RequireSellerRole = ({ children }) => {
	const auth = useSelector((state) => state.auth);
	const role = auth?.user?.role;
	if (role !== "SELLER") return <Navigate to="/organizer" replace />;
	return children;
};

const MainRoutes = () => {
	const [webname, setWebname] = useState("Zoco Tickets");
	const [googleClientId, setGoogleClientId] = useState("");
	const [appSettings, setAppSettings] = useState({});
	const location = useLocation();
	const auth = useSelector((state) => state.auth);

	useEffect(() => {
		const routeTitles = {
			"/": `Inicio - ${webname}`,

			"/event": `Eventos - ${webname}`,

			"/blog": `Blog - ${webname}`,

			"/contact-us": `Contáctanos - ${webname}`,

			"/search": `Buscar - ${webname}`,
			"/reservas": `Reservas - ${webname}`,
			"/reservas/historial": `Mis reservas - ${webname}`,
			"/canchas": `Canchas - ${webname}`,
			"/canchas/historial": `Mis reservas - ${webname}`,
			"/beauty": `Beauty - ${webname}`,
			"/beauty/historial": `Mis reservas - ${webname}`,

			"/cart": `Carrito - ${webname}`,
			"/arrepentimiento": `Botón de arrepentimiento - ${webname}`,
		};

		let title = routeTitles[location.pathname];

		if (!title) {
			if (location.pathname.startsWith("/shop/product")) {
				title = `Producto - ${webname}`;
			} else if (location.pathname.startsWith("/blog/detail")) {
				title = `Blog - ${webname}`;
			} else {
				title = webname;
			}
		}

		document.title = title;
	}, [location, webname]);

	const fetchAppSettings = async () => {
		try {
			const response = await getAppSettings();

			setAppSettings(response.data.info);

			setWebname(response.data.info.name);

			setGoogleClientId(response.data.info.google_login_client_id);
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		fetchAppSettings();
	}, []);

	const isOrganizerPanelRole =
		auth?.isAuthenticated &&
		["ORGANIZER", "SELLER"].includes(
			String(auth?.user?.role || "").toUpperCase(),
		);
	// /entrar no: una pestaña con sesión de organizador de un negocio tiene que poder canjear el
	// código de otro. Este salto la mandaría al panel antes del canje y la dejaría parada en el
	// negocio viejo. Es la misma excepción que el efecto de AppRoutes2: son dos copias de la regla.
	if (isOrganizerPanelRole && !location.pathname.startsWith("/organizer") && !location.pathname.startsWith("/entrar")) {
		return <Navigate to="/organizer" replace />;
	}

	return (
		<Suspense fallback={<Spinner animation="border" variant="primary" />}>
			<Routes>
				<Route
					path="/register"
					element={
						<PublicLoginRoute>
							<RegisterForm />
						</PublicLoginRoute>
					}
				></Route>

				<Route
					path="/login"
					element={
						<PublicLoginRoute>
							{googleClientId ? (
								<GoogleOAuthProvider clientId={googleClientId}>
									<Login />
								</GoogleOAuthProvider>
							) : (
								<Spinner animation="border" variant="primary" />
							)}
						</PublicLoginRoute>
					}
				></Route>

				<Route
					path="/login/forgotpassword"
					element={
						<PublicRoute>
							<ForgotPassword />
						</PublicRoute>
					}
				></Route>

				{/* La vuelta del portal de Zoco con ?codigo= (Productos:Tickets:Url). Sin PublicLoginRoute
				    a propósito: una pestaña que ya tiene sesión tiene que poder cambiarla por la del
				    negocio nuevo. */}
				<Route path="/entrar" element={<EntrarDesdeZoco />} />

				<Route path="/" element={<Navigate to="/event" replace />} />

				<Route path="/event" element={<Event />}></Route>
				<Route path="/event/:id" element={<EventDetail />}></Route>
				<Route path="/reservas" element={<Reservas />}></Route>
				<Route path="/reservas/historial" element={<Historial />}></Route>
				<Route path="/reservas/gestionar/:token" element={<ManageReservation />}></Route>
				<Route path="/reservas/resenar/:token" element={<ReviewByLink />}></Route>
				<Route path="/lista-de-espera/baja/:token" element={<WaitlistLeave />}></Route>
				<Route path="/lista-de-espera/reservar/:token" element={<WaitlistClaim />}></Route>
				<Route path="/novedades/baja/:token" element={<NewsUnsubscribe />}></Route>
				<Route path="/reservas/success" element={<ReservaSuccess />}></Route>
				<Route path="/reservas/cancel" element={<ReservaCancel />}></Route>
				<Route path="/reservas/:barId" element={<BarDetail />}></Route>
				<Route path="/canchas" element={<Canchas />}></Route>
				<Route path="/canchas/historial" element={<Historial />}></Route>
				<Route
					path="/canchas/success"
					element={<LegacyReservationOutcomeRedirect to="/reservas/success" />}
				></Route>
				<Route
					path="/canchas/cancel"
					element={<LegacyReservationOutcomeRedirect to="/reservas/cancel" />}
				></Route>
				<Route path="/canchas/:clubId" element={<ClubDetail />}></Route>
				<Route path="/canchas/:clubId/cumpleanos" element={<BirthdayFlow />}></Route>
				<Route path="/canchas/:clubId/partidos" element={<ClubOpenMatches />}></Route>
				<Route path="/partidos/compartir/:shareToken" element={<OpenMatchDetail />}></Route>
				<Route path="/partidos/:id" element={<OpenMatchDetail />}></Route>
				<Route path="/cumpleanos/solicitud/:token" element={<BirthdayRequestPage />}></Route>
				<Route path="/beauty" element={<BeautyListing />}></Route>
				<Route path="/beauty/historial" element={<Historial />}></Route>
				<Route path="/beauty/:salonRef" element={<SalonDetail />}></Route>
				<Route path="/beauty/:salonRef/:profesionalSlug" element={<SalonDetail />}></Route>
				<Route path="/preview/:token" element={<PreviewEntry />}></Route>

				<Route path="/search" element={<Search />}></Route>

				<Route path="/contact-us" element={<ContactUs />}></Route>

				<Route path="/blog" element={<Blog />}></Route>

				<Route path="/blog/:id" element={<BlogDetail />}></Route>

				{/* Organizer dashboard */}

				<Route
					path="/organizer/*"
					element={
						<PrivateOrganizerRoute>
							<OrganizerLayout />
						</PrivateOrganizerRoute>
					}
				>
					<Route index element={<OrganizerIndexGate />} />
					<Route
						path="presencial"
						element={
							<RequireTarjetaDelNegocio ruta="/organizer/presencial">
								<OrganizerPhysicalTickets />
							</RequireTarjetaDelNegocio>
						}
					/>
					<Route
						path="presencial/print/:batchId"
						element={
							<RequireTarjetaDelNegocio ruta="/organizer/presencial">
								<OrganizerPhysicalPrintBatch />
							</RequireTarjetaDelNegocio>
						}
					/>

					<Route
						path="asistencia"
						element={
							<RequireOrganizerRole ruta="/organizer/asistencia">
								<OrganizerLiveAttendance />
							</RequireOrganizerRole>
						}
					/>

					<Route
						path="events"
						element={
							<RequireOrganizerRole ruta="/organizer/events">
								<OrganizerEventsList />
							</RequireOrganizerRole>
						}
					/>

					<Route
						path="events/new"
						element={
							<RequireOrganizerRole ruta="/organizer/events">
								<OrganizerEventGuidedFlow />
							</RequireOrganizerRole>
						}
					/>

					<Route
						path="events/:id"
						element={
							<RequireOrganizerRole ruta="/organizer/events">
								<OrganizerEventForm />
							</RequireOrganizerRole>
						}
					/>

					<Route
						path="scanners"
						element={
							<RequireOrganizerRole ruta="/organizer/scanners">
								<OrganizerScanners />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="sellers"
						element={
							<RequireOrganizerRole ruta="/organizer/sellers">
								<OrganizerSellers />
							</RequireOrganizerRole>
						}
					/>

					<Route
						path="coupons"
						element={
							<RequireOrganizerRole ruta="/organizer/coupons">
								<OrganizerCoupons />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="gifts"
						element={
							<RequireTarjetaDelNegocio ruta="/organizer/gifts">
								<OrganizerGiftTickets />
							</RequireTarjetaDelNegocio>
						}
					/>
					<Route
						path="referidos"
						element={
							<RequireSellerRole>
								<OrganizerReferrals />
							</RequireSellerRole>
						}
					/>
					<Route
						path="sponsors"
						element={
							<RequireOrganizerRole ruta="/organizer/sponsors">
								<OrganizerSponsors />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="orders"
						element={
							<RequireOrganizerRole ruta="/organizer/orders">
								<OrganizerOrders />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="reports"
						element={
							<RequireOrganizerRole ruta="/organizer/reports">
								<OrganizerReports />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="marketing"
						element={
							<RequireOrganizerRole ruta="/organizer/marketing">
								<OrganizerMarketing />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="reservas"
						element={
							<RequireOrganizerRole ruta="/organizer/reservas">
								<OrganizerReservas />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="canchas"
						element={
							<RequireOrganizerRole ruta="/organizer/canchas">
								<CanchasOrganizer />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="canchas/cumpleanos"
						element={
							<RequireOrganizerRole ruta="/organizer/canchas/cumpleanos">
								<BirthdayInbox />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="estadisticas/canchas"
						element={
							<RequireOrganizerRole ruta="/organizer/estadisticas/canchas">
								<EstadisticasCanchas />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="estadisticas/beauty"
						element={
							<RequireOrganizerRole ruta="/organizer/estadisticas/beauty">
								<EstadisticasBeauty />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="turnos"
						element={
							<RequireOrganizerRole ruta="/organizer/turnos">
								<TurnosOrganizer />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="clientes"
						element={
							<RequireOrganizerRole ruta="/organizer/clientes">
								<ClientesOrganizer />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="payments"
						element={
							<RequireOrganizerRole ruta="/organizer/payments">
								<OrganizerPayments />
							</RequireOrganizerRole>
						}
					/>
					<Route
						path="notificaciones"
						element={
							<RequireOrganizerRole ruta="/organizer/notificaciones">
								<OrganizerNotificationPreferences />
							</RequireOrganizerRole>
						}
					/>
				</Route>
				<Route
					path="/cart"
					element={
						<PrivateRoute>
							<Cart />
						</PrivateRoute>
					}
				></Route>

				<Route
					path="/payment/cancel"
					element={
						<PrivateRoute>
							<Cancel />
						</PrivateRoute>
					}
				></Route>

				{/* Removed legacy /checkout route */}

				{/* Fiserv success/cancel endpoints (public; backend redirects here) */}
				<Route
					path="/payment/fiserv/success"
					element={<SuccessFiservPage />}
				></Route>
				<Route
					path="/payment/fiserv/cancel"
					element={<CancelFiservPage />}
				></Route>
				{/* Optional short aliases */}
				<Route path="/fiserv/success" element={<SuccessFiservPage />} />
				<Route path="/fiserv/cancel" element={<CancelFiservPage />} />
				{/* Generic alias used by Fiserv return URL configuration */}
				<Route path="/success" element={<SuccessFiservPage />} />

				<Route
					path="/payment/success"
					element={
						<PrivateRoute>
							<SuccessCloverPage />
						</PrivateRoute>
					}
				></Route>

				<Route
					path="/cancel"
					element={
						<PrivateRoute>
							<Cancel />
						</PrivateRoute>
					}
				></Route>

				<Route
					path="/eventhistory"
					element={
						<PrivateRoute>
							<Order />
						</PrivateRoute>
					}
				></Route>
				<Route
					path="/myevents"
					element={
						<PrivateRoute>
							<MyEvents />
						</PrivateRoute>
					}
				></Route>
				<Route
					path="/account/profile"
					element={
						<PrivateRoute>
							<AccountProfile />
						</PrivateRoute>
					}
				></Route>
				<Route
					path="/account/password"
					element={
						<PrivateRoute>
							<AccountPassword />
						</PrivateRoute>
					}
				></Route>
				<Route
					path="/myevents/:eventid"
					element={
						<PrivateRoute>
							<MyEventDetail />
						</PrivateRoute>
					}
				></Route>
				<Route
					path="/myevents/:eventid/transfer"
					element={
						<PrivateRoute>
							<TransferTickets />
						</PrivateRoute>
					}
				></Route>
				<Route
					path="/complete-profile"
					element={
						<PrivateRoute>
							<CompleteProfile />
						</PrivateRoute>
					}
				></Route>
				{/* <Route path="/orderqr/:id" element={<Orderqr />}></Route> */}

				{/* Safe login route that waits for Google clientId */}
				<Route
					path="/login2"
					element={
						<PublicLoginRoute>
							<LoginGate />
						</PublicLoginRoute>
					}
				></Route>

				<Route path="/privacypolicy" element={<PrivacyPolicy />}></Route>
				<Route path="/arrepentimiento" element={<RegretButton />}></Route>

				{/* Ticket transfer claim (public, ensures login) */}
				<Route path="/transfer/accept" element={<TransferAccept />}></Route>
				{/* Optional short alias in case backend used /tran */}
				<Route path="/tran" element={<TransferAccept />}></Route>
				<Route
					path="/termsandcondition"
					element={<TermsAndCondition />}
				></Route>

				{/* (removed duplicate private fiserv routes to avoid conflicts) */}

				<Route path="*" element={<NotFound />} />
			</Routes>
		</Suspense>
	);
};

export default MainRoutes;
